import { getToken } from "./utils";

const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000") + "/templates";

async function buildApiError(response, fallbackMessage) {
  try {
    const payload = await response.json();
    const detail = payload?.detail ?? payload?.message ?? payload;
    return new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
  } catch (_error) {
    return new Error(fallbackMessage);
  }
}

function authHeaders() {
  return {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  };
}

export async function getTemplateAssets(templateId) {
  const response = await fetch(`${API_URL}/templates/${templateId}/assets`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  if (!response.ok) throw await buildApiError(response, "Failed to load template assets");
  return await response.json();
}

export async function createTemplateAsset(templateId, asset) {
  const response = await fetch(`${API_URL}/templates/${templateId}/assets`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(asset),
  });

  if (!response.ok) throw await buildApiError(response, "Failed to create template asset");
  return await response.json();
}

export async function updateTemplateAsset(assetId, asset) {
  const response = await fetch(`${API_URL}/template-assets/${assetId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(asset),
  });

  if (!response.ok) throw await buildApiError(response, "Failed to update template asset");
  return await response.json();
}

export async function deleteTemplateAsset(assetId) {
  const response = await fetch(`${API_URL}/template-assets/${assetId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });

  if (!response.ok) throw await buildApiError(response, "Failed to delete template asset");
  return await response.json();
}
